import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { FormField, ResultCard, EducationalBlock } from './shared';

const CPFValidator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [formattedCpf, setFormattedCpf] = useState('');
  const [isValid, setIsValid] = useState<boolean | null>(null);

  const validateCPF = (cpf: string) => {
    const cleanCPF = cpf.replace(/[^\d]/g, '');
    if (cleanCPF.length !== 11) return { valid: false, message: 'CPF deve ter 11 dígitos' };
    const firstDigit = cleanCPF.charAt(0);
    if (cleanCPF.split('').every(digit => digit === firstDigit)) return { valid: false, message: 'CPF inválido' };

    let sum = 0;
    let weight = 10;
    for (let i = 0; i < 9; i++) {
      sum += parseInt(cleanCPF.charAt(i)) * weight;
      weight--;
    }
    let remainder = sum % 11;
    let firstVD = remainder < 2 ? 0 : 11 - remainder;

    sum = 0;
    weight = 11;
    for (let i = 0; i < 10; i++) {
      sum += parseInt(cleanCPF.charAt(i)) * weight;
      weight--;
    }
    remainder = sum % 11;
    let secondVD = remainder < 2 ? 0 : 11 - remainder;

    if (firstVD !== parseInt(cleanCPF.charAt(9)) || secondVD !== parseInt(cleanCPF.charAt(10))) {
      return { valid: false, message: 'Dígitos inválidos' };
    }
    return { valid: true, message: 'CPF válido' };
  };

  const formatCPF = (cpf: string) => {
    const clean = cpf.replace(/[^\d]/g, '');
    if (clean.length <= 3) return clean;
    if (clean.length <= 6) return `${clean.slice(0, 3)}.${clean.slice(3)}`;
    if (clean.length <= 9) return `${clean.slice(0, 3)}.${clean.slice(3, 6)}.${clean.slice(6)}`;
    return `${clean.slice(0, 3)}.${clean.slice(3, 6)}.${clean.slice(6, 9)}-${clean.slice(9, 11)}`;
  };

  const handleValidate = () => {
    const clean = formattedCpf.replace(/[^\d]/g, '');
    const res = validateCPF(clean);
    setIsValid(res.valid);
    onResultChange([{ label: 'Documento', value: 'CPF' }, { label: 'Número', value: formattedCpf }, { label: 'Status', value: res.valid ? 'Válido' : 'Inválido' }]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
          <FormField label="CPF" placeholder="000.000.000-00" value={formattedCpf} onChange={v => setFormattedCpf(formatCPF(v))} required />
          <div className="flex items-center pt-6">
            <button onClick={handleValidate} className="px-8 py-3 bg-accent-gradient text-white rounded-xl font-bold hover:scale-105 transition-all flex items-center gap-2">
              <Icon name="check-circle" className="w-5 h-5" /> Validar
            </button>
          </div>
        </div>
        {isValid !== null && <ResultCard title="Status" value={isValid ? 'Válido' : 'Inválido'} color={isValid ? 'green' : 'red'} />}
      </div>
      <EducationalBlock title="Dicas CPF" tips={['Deve ter 11 dígitos', 'Validado por algoritmos de dígitos verificadores']} />
    </div>
  );
};

export default CPFValidator;
